import React, { FunctionComponent } from "react";
import { SxProps } from "@mui/system";
import { styled } from "@mui/material/styles";
import Container, { ContainerProps } from "@mui/material/Container";
import Notification from "components/notification/Notification";

export interface AppLayoutProps {
  fullWidth?: boolean;
  backgroundColor?: string;
  disableGutters?: boolean;
  disableGuttersX?: boolean;
  disableGuttersY?: boolean;
  sx?: SxProps;
  children: JSX.Element | JSX.Element[];
}

const defaultGuttersX: any = {
  paddingRight: "6rem",
  paddingLeft: "10rem",
};
const defaultGuttersY: any = {
  paddingTop: "2.4rem",
  paddingBottom: "2.4rem",
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CustomContainer = styled(Container)<ContainerProps>(({ theme }) => ({
  "&.MuiContainer-root": {
    maxWidth: "100%",
    width: "100vw",
    marginLeft: "0",
    marginRight: "0",
    background: "#F3F7FD",
  },
  "&.MuiContainer-fixed": {
    width: "auto",
    maxWidth: "1224px",
    marginLeft: "auto",
    marginRight: "auto",
    boxSizing: "content-box",
  },
  "&:last-child": {
    paddingBottom: "10rem",
  },
}));

export const AppLayout: FunctionComponent<AppLayoutProps> = (props) => {
  const { fullWidth, backgroundColor, disableGutters, disableGuttersX, disableGuttersY, sx, children } = props;

  let bgColor: string = backgroundColor || "transparent";
  if (fullWidth && !backgroundColor) {
    bgColor = "var(--blue-2)";
  }

  let gutters: any = { ...defaultGuttersX, ...defaultGuttersY };
  if (disableGutters) {
    gutters = {};
  } else if (disableGuttersX) {
    gutters = { ...defaultGuttersY };
  } else if (disableGuttersY) {
    gutters = { ...defaultGuttersX };
  }
  return (
    <CustomContainer
      disableGutters
      fixed={!fullWidth}
      sx={{
        boxSizing: fullWidth ? "border-box" : "content-box",
        backgroundColor: bgColor,
        ...gutters,
        ...sx,
      }}
    >
      <Notification/>
      {children}
    </CustomContainer>
  );
};
